export default __webpack_public_path__ + "static/media/Vector-fam.44effec7.svg";